import { pickBy } from '@/utils'

export default {
  name: 'devices',
  setting: [
    // { label: "楼层", key: "floor_var", component: "input", required: true },
    // {
    //   label: "展示图",
    //   key: "backgroundImage",
    //   component: function (h, { key }) {
    //     return <SpImagePicker v-model={this.value[key]} size="small" />;
    //   },
    //   value: "",
    // }
  ],
  transformIn: async (v) => {
    const { name, base, config } = v;
    return {
      name,
      ...base,
      ...config,
    }
  },
  transformOut: (v) => {
    const { floor_var } = v
    // if (!floor_var) {
    //   throw '[挂件]设备绑定 请输入楼层';
    // }

    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          floor_var: "floor_var",
        });
      },
      config: (v) => {
        return pickBy(v, {
          // backgroundImage: 'backgroundImage',
        });
      },
    })
  }
}
